var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2542_37306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.95508 6.21599V4.21599C1.95508 3.42034 2.27115 2.65728 2.83376 2.09467C3.39637 1.53206 4.15943 1.21599 4.95508 1.21599C5.75073 1.21599 6.51379 1.53206 7.0764 2.09467C7.63901 2.65728 7.95508 3.42034 7.95508 4.21599V6.21599",
    stroke: "#343B53",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95508 6.54932C7.95508 6.72613 7.88484 6.8957 7.75982 7.02072C7.63479 7.14575 7.46522 7.21599 7.28841 7.21599H6.95508C6.77827 7.21599 6.6087 7.14575 6.48367 7.02072C6.35865 6.8957 6.28841 6.72613 6.28841 6.54932V5.54932C6.28841 5.37251 6.35865 5.20294 6.48367 5.07791C6.6087 4.95289 6.77827 4.88265 6.95508 4.88265H7.95508V6.54932ZM1.95508 6.54932C1.95508 6.72613 2.02532 6.8957 2.15034 7.02072C2.27536 7.14575 2.44493 7.21599 2.62174 7.21599H2.95508C3.13189 7.21599 3.30146 7.14575 3.42648 7.02072C3.55151 6.8957 3.62174 6.72613 3.62174 6.54932V5.54932C3.62174 5.37251 3.55151 5.20294 3.42648 5.07791C3.30146 4.95289 3.13189 4.88265 2.95508 4.88265H1.95508V6.54932Z",
    stroke: "#343B53",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2542_37306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0.955078 0.215988)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIc);
export default __webpack_public_path__ + "static/media/audio-ic.36eed2afafbf0a4d72b7a91dd6da3f32.svg";
export { ForwardRef as ReactComponent };